<div>
  <app-header></app-header>
  <div [ngStyle]="{'min-height': 'calc(45vh)'}">
    <router-outlet></router-outlet>
  </div>

  <div class="mt-5">
    <app-footer></app-footer>
  </div>
</div>